'use client';

export { ErrorPage as default } from '@svenskaspelab/nova-foundation/nextjs/pages';
